<div class="row transition5" style="height: 100vh;">
  <div class="menu-container" [ngClass]="[
      settings.menuToggleSetting ? 'expanded-menu' : 'collapsed-menu unset-p',
      settings.darkModeSetting ? 'bg-dark change-scrollbar-color-darkMode' : 'bg-white change-scrollbar-color']">
    <div class="flex animated fadeIn cursorPointer align-centre menu-header"
      (click)="settings.menuToggleSetting = !settings.menuToggleSetting"
      [ngClass]="{'justify-centre': !settings.menuToggleSetting}">
      <div id="nav-icon1" class="textWhite font20" [ngClass]="{open: settings.menuToggleSetting}">
        <span class="bg-green"></span>
        <span class="bg-blue"></span>
        <span class="bg-orange"></span>
      </div>
      <ng-template [ngIf]="app.siteName && (settings.menuToggleSetting || mobileView)">
        <span class="font14 animated fadeIn absolute site-name" style="left: 37px"
          [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'">
          {{app.siteName}}
        </span>
      </ng-template>
    </div>
    <div class="animated fadeIn sticky full-width menu-content"
      [ngStyle]="{'z-index': settings.menuToggleSetting ? '1' : '0'}"
      [ngClass]="settings.darkModeSetting ? 'bg-dark': 'bg-white'">
      <ng-template [ngIf]="settings">
        <app-menu [item]="undefined" [userId]="userId" [settings]="settings"></app-menu>
      </ng-template>
    </div>
  </div>
  <div class="animated fadeIn view-container"
    [ngClass]="settings.darkModeSetting ? 'bg-dark change-scrollbar-color-darkMode' : 'bg-white change-scrollbar-color'">
    <div class="flex align-centre sticky toolbar" [ngStyle]="{ 'height': mobileView ? '8svh' : '50px' }"
      [ngClass]="settings.darkModeSetting ? 'bg-dark' : 'bg-white'">
      <ng-template [ngIf]="mobileView">
        <div class="flex animated fadeIn cursorPointer align-centre menu-header"
          (click)="settings.menuToggleSetting = !settings.menuToggleSetting"
          [ngClass]="{'justify-centre': !settings.menuToggleSetting}">
          <div id="nav-icon1" class="textWhite font20" [ngClass]="{open: settings.menuToggleSetting}">
            <span class="bg-green"></span>
            <span class="bg-blue"></span>
            <span class="bg-orange"></span>
          </div>
        </div>
      </ng-template>
      <div class="unset-p" [ngClass]="mobileView ? 'col-9' : 'col-10'">
        <div class="flex">
          <app-rad class="rad-comp" [settings]="settings" [nodeId]="nodeId" [userId]="userId" [mobileView]="mobileView"></app-rad>
        </div>
      </div>
      <div class="col-2 flex justify-right">
        <div class="relative notification-base" style="padding: 7px 12px;">
          <button class="font16 unset-b b-radius"
            [ngClass]="settings.darkModeSetting ? 'textWhite bg-dark-secondary' : 'textBlue bg-light-blue'"
            (click)="openNotifications()">
            <fa-icon [icon]="faBell"></fa-icon>
          </button>
          <ng-template [ngIf]="hasUnreadNotifications">
            <fa-icon [icon]="faCircle" class="absolute textRed" style="right: 7px;"></fa-icon>
          </ng-template>
        </div>
        <span class="pull-left font18 bg-blue textWhite cursorPointer" style="padding: 6px 15px; border-radius: 50%;"
          (click)="openUserMenu()">
          {{username.charAt(0)}}
        </span>
        <ng-template [ngIf]="translationsLoaded && !isUserMenuCollapsed">
          <div class="absolute animated box-shadow b-radius user-menu-container"
            [ngClass]="settings.darkModeSetting ? 'bg-dark' : 'bg-white'">
            <user-menu-component [settings]="settings" [username]="username" [userRole]="userRole" [greeting]="greeting"
              [mobileView]="mobileView" [dashboardCarouselList]="dashboardCarouselList"></user-menu-component>
          </div>
        </ng-template>
      </div>
    </div>
    <ng-template [ngIf]="!gridView && !ganttView && !mapView">
      <div class="relative full-width transition5 animated padding5 fadeIn full-vh-height"
        [ngClass]="settings.darkModeSetting ? 'bg-gradient-dark' : 'bg-gradient'">
        <img class="absolute padding22 b-radius no-view" src="../assets/img/logo.png" />
      </div>
    </ng-template>
    <ng-template [ngIf]="gridView">
      <app-grid [userId]="userId" [username]="username" [mobileView]="mobileView" [settings]="settings"
        [nodeId]="nodeId" [mainGridName]="mainGridName" style="flex: 1; display: flex; flex-direction: column; min-height: 0;"></app-grid>
    </ng-template>
    <ng-template [ngIf]="ganttView">
      <app-gantt [userId]="userId" [username]="username" [nodeId]="nodeId" [settings]="settings"></app-gantt>
    </ng-template>
    <ng-template [ngIf]="mapView">
      <app-map [nodeId]="nodeId" [userId]="userId" [username]="username" [settings]="settings"
        [translations]="translations"></app-map>
    </ng-template>
  </div>
</div>
<ng-template [ngIf]="!settings.storageConsent">
  <div
    class="row animated slideInUp flex box-shadow sticky full-width justify-centre align-centre blur cookie-container"
    [ngClass]="{'slideInUp': !settings.storageConsent, 'slideOutDown': settings.storageConsent}">
    <div class="col-6 flex align-centre justify-centre">
      <span class="font14" [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlue'">
        <ng-template [ngIf]="app.translations != undefined">
          {{app.translations.COOKIEBANNER_Desc}} - <span (click)="openStoragePolicy()"
            class="textGreen cursorPointer">{{app.translations.COOKIEBANNER_Lnk}}</span>
        </ng-template>
      </span>
    </div>
    <div class="col-1">
      <button class="btn float-right" (click)="consentToStorage()">
        <span class="font14" [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlue'">
          <fa-icon [icon]="faXmark"></fa-icon>
        </span>
      </button>
    </div>
  </div>
</ng-template>

<ng-template [ngIf]="action && action.type == 'MultiParamSqlExecuteAction'">
  <form-action-component [headers]="headers" [selectedItems]="selectedLines" [action]="action" [nodeId]="nodeId"
    [userId]="userId" [username]="username" [mobileView]="mobileView" [settings]="settings"></form-action-component>
</ng-template>

<ng-template [ngIf]="action && action.type == 'MultiParamGridAction'">
  <grid-action-component [headers]="headers" [selectedLines]="selectedLines" [settings]="settings" [action]="action"
    [nodeId]="nodeId" [userId]="userId" [username]="username"></grid-action-component>
</ng-template>

<ng-template [ngIf]="action && action.type == 'SqlExecuteAction'">
  <sql-action-component [selectedItems]="selectedLines" [action]="action" [nodeId]="nodeId" [userId]="userId"
    [settings]="settings"></sql-action-component>
</ng-template>

<ng-template [ngIf]="feedbackMessage">
  <feedback-component [feedbackMessage]="feedbackMessage" [darkMode]="settings.darkModeSetting"></feedback-component>
</ng-template>

<ng-template [ngIf]="headersToEdit">
  <column-component [headers]="headersToEdit" [nodeId]="nodeId" [username]="username" [viewName]="viewName"
    [settings]="settings" [userId]="userId"></column-component>
</ng-template>

<ng-template [ngIf]="imageToExpand">
  <image-viewer-component [image]="imageToExpand" [settings]="settings"></image-viewer-component>
</ng-template>

<ng-template [ngIf]="showSettings">
  <settings-component [settings]="settings" [mobileView]="mobileView"></settings-component>
</ng-template>

<ng-template [ngIf]="showNotifications">
  <app-notification-component [userId]="userId" [username]="username"
    [settings]="settings"></app-notification-component>
</ng-template>

<ng-template [ngIf]="showImportFileDialog">
  <import-component [settings]="settings" [mobileView]="mobileView"></import-component>
</ng-template>

<ng-template [ngIf]="showAdvancedFilters">
  <advanced-filters-component [filters]="filters" [serverDateFormat]="serverDateFormat" [settings]="settings"
    [headers]="headers" [filterString]="filterString" [nodeId]="nodeId"
    [detailViewName]="detailViewName"></advanced-filters-component>
</ng-template>

<ng-template [ngIf]="showExportDialog">
  <export-component [headers]="headers" [lines]="lines" [mobileView]="mobileView" [mapView]="mapView"
    [settings]="settings" [nodeId]="nodeId" [userId]="userId" [viewName]="viewName" [keyValue]="keyValue"
    [filterString]="filterString" [username]="username"></export-component>
</ng-template>

<ng-template [ngIf]="showStorageManagement">
  <storage-management-component [settings]="settings"></storage-management-component>
</ng-template>